import React from "react";
import BaseTemplate from "../../BaseTemplate";
import { getPath } from "./getPath";

const ChemoRegimenFilterBase = () => <BaseTemplate getPath={getPath} />;

export default ChemoRegimenFilterBase;
